<template>
    <div id="acccountUser">
        <div id="contentArea2"
             class="row col-lg-12 col-md-12 col-sm-12 px-0 mt-3">
            <div class="col-lg-3 col-md-3 col-sm-3 float-left px-0">
                <AccountNavigation :selectedAccountNumber="selectedAccount" ref="accountNavigation" v-if="selectedAccount.accountNumber != ''" />
            </div>
            <div class="col-lg-9 col-md-9 col-sm-9 float-right">
                <div class="d-flex align-items-center mb-2">
                    <div class="search-term flex-grow-1">
                       <span class="selected-account-banner">Account Name: {{selectedAccount.accountName}}, Account Number: {{selectedAccount.accountNumber}}</span>
                        <!--<span
      v-if="isDefaultAccountActive == true"
      class="selected-account-banner"
    >{{selectedAccount.accountName}}</span>-->
                    </div>
                    <b-button class="add-user-btn ms-2"
                              @click="$event.target.blur(); openSearchEmail();"
                              :disabled="selectedAccount.accountNumber==''">
                        Add User
                    </b-button>
                </div>
                <div>
                    <UserList :srcAccount="selectedAccount"
                              :users-source="gridData"
                              :isBusy="isBusy"
                              :freshLoad="true"
                              ref="usergrid" />
                </div>
                <br />
            </div>
        </div>
        <SearchEmail ref="searchEmail"
                     :accountNumber="selectedAccount.accountNumber"
                     :accountName="selectedAccount.accountName"
                     :accountId="selectedAccount.accountId" />
        <CreateAdfsUser ref="createAdfsUserRef"
                        :isNewUser="false"
                        :userEmailId="selectedUser.email"
                        :accountName="selectedAccount.accountName"
                        :accountNumber="selectedAccount.accountNumber"
                        :accountId="selectedAccount.accountId"
                        :searchedUserDetail="selectedUser"
                        @OnCreateAdfsUserModalCancel="closeCreateAdfsUserModal"
                        :actionFromEdit="true"></CreateAdfsUser>
        <ErrorMessage ref="errorMessageRef" :errorMessage="errorMsg"
                      callbackOnClose="cancelChanges"
                      @cancelChanges="cancelChanges"></ErrorMessage>
        <!--<loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>-->
    </div>
</template>

<script>
    import UserList from "./shared/UserList";
    import AccountNavigation from "./shared/AccountNavigation";
    //import "vue-select/dist/vue-select.css";
    import SearchEmail from "./SearchEmail";
    //import { Component as Loading } from "vue-loading-overlay";
    //import "vue-loading-overlay/dist/css/index.css";
    import { eventbus } from "../main";
    import service from "../services/api.services";
    import CreateAdfsUser from "./shared/CreateAdfsUser";
    import ErrorMessage from "./shared/ErrorMessage";

    export default {
        name: "AccountUser",
        components: {
            AccountNavigation,
            UserList,
            SearchEmail,
            //Loading,
            CreateAdfsUser,
            ErrorMessage
        },
        data() {
            return {
                //posts: [],
                //isNavLoading: false,
                //isNavLoaded: false,
                isDefaultAccountActive: false,
                csAccounts: [],
                //searchQuery: "",
                gridData: [],
                defaultNoneAccountOption: {
                    accountName: "No Accounts Found ",
                    accountNumber: "",
                    accountId: "",
                    isPrimary: false
                },
                optionConcat: "-",
                //accountList: [{ accountName: "", accountNumber: "", accountId: "" }],
                //accounts: [],
                selectedUser: {},
                modalShow: false,
                //isLoading: false,
                isBusy: false,
                fullPage: true,
                //isPageLoaded: false,
                contactListwithoutUserName: [],
                pagedcontactListwithUserName:[],
                errorMsg: "",
                selectedAccount: this.defaultAccount
            };
        },
        props: {
            defaultAccount: {}
        },
        watch: {
            gridData: function (newValue) {
                this.gridData = newValue;
                this.$refs.usergrid.resetFilteredOption()
                this.$refs.usergrid.resetPagingOptions()
                if (
                    this.contactListwithoutUserName != null &&
                    this.contactListwithoutUserName.length > 0
                )
                    this.$refs.usergrid.GetUserNameByAdfs(this.contactListwithoutUserName);
                if (
                    this.pagedcontactListwithUserName != null &&
                    this.pagedcontactListwithUserName.length > 0
                )
                this.$refs.usergrid.GetUserStatusByUserName(this.pagedcontactListwithUserName);
            }
        },
        methods: {
            setEmits: function () {
                var that = this;
                eventbus.on("UserCreatedSuccessfully", function (data) {
                    that.UserCreatedSuccessfully(data);
                });
                eventbus.on("OnUserListAddUser", function (data) {
                    that.createAdfsUserForContact(data);
                });
                eventbus.on("OnDeactivatedContact", function () {
                    that.errorMsg = "Sorry, the associated contact is deactived.";
                    if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                        that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                    else
                        that.$bvModal.show("errormessage");
                });
                eventbus.on("OnAccountNumberChange", function (accountNumber) {
                    //console.log('i am called ', accountNumber);
                    that.OnAccountNumberChange(accountNumber);
                });
            },

            openSearchEmail: function () {
                this.$refs.searchEmail.clearForm();
                this.$refs.searchEmail.$refs.searchedEmailId = "";
                this.$bvModal.show("searchemail");
                setTimeout(() => {
                    this.$refs.searchEmail.$refs.searchedEmailId.focus();
                }, 200);
            },
            UserCreatedSuccessfully: function (data) {
                if (data.userCreated == true) {
                    this.$bvModal.hide("searchemail");
                    if (this.$refs.createAdfsUserRef && this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"])
                        this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"].hide();
                    else
                        this.$bvModal.hide("createadfsuser");
                    //this.GetData(this.selectedAccount.accountNumber);:TODO Made changes here to load grid after save
                }
            },
            OnAccountNumberChange(data) {
                if (data.accountId != "") {
                    this.selectedAccount = data;
                    this.GetData(data.accountId);
                } else if (data.accountId == "") {
                    this.gridData = [];
                }
            },
            GetData: function (selectedAccount) {
                var that = this;
                that.contactListwithoutUserName = [];
                that.isBusy = true;
                //that.isNavLoading = true;
                if (selectedAccount != "") {
                    service
                        .GetUserDetailsByAccountId(selectedAccount)
                        .then(result => {
                            if (result.data == "") {
                                that.gridData = [];
                            } else {
                                that.GetContactsWithoutUserNames(result.data);
                                
                                that.gridData = result.data.sort(function (a, b) {
                                    return (typeof a.firstName == "undefined" || a.firstName == null || a.firstName == "") ? -1
                                        : (typeof b.firstName == "undefined" || b.firstName == null || b.firstName == "") ? 1
                                        : (a.firstName.toLowerCase() < b.firstName.toLowerCase()) ? -1
                                        : (a.firstName.toLowerCase() > b.firstName.toLowerCase()) ? 1 : 0
                                });
                                that.GetContactsWithUserNames(that.gridData);
                            }
                            that.isBusy = false;
                            //that.isNavLoading = false;
                        })
                        .catch(error => {
                            console.log("api error:" + error);
                            that.gridData = [];
                            that.isBusy = false;
                        });
                } else {
                    that.gridData = [];
                }

            },
            createAdfsUserForContact: function (data) {
                this.selectedUser = data;
                this.$store.dispatch("setSearchedUserDetail", this.selectedUser);
                this.emitContactDetails();
                if (this.$refs.createAdfsUserRef && this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"])
                    this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"].show();
                else
                    this.$bvModal.show("createadfsuser");
            },
            cancelChanges: function () { },
            closeCreateAdfsUserModal: function () {
                if (this.$refs.createAdfsUserRef && this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"])
                    this.$refs.createAdfsUserRef.$refs["createAdfsUserModal"].hide();
                else
                    this.$bvModal.hide("createadfsuser");
            },
            emitContactDetails: function () {
                eventbus.emit(
                    "setuserDetails",
                    [this.$store.getters.searchedUserDetail, false]
                );
            },
            GetContactsWithoutUserNames: function (data) {
                var that = this;
                data.forEach(function (key) {
                    if (
                        typeof key != "undefined" &&
                        (key.userName == null || key.userName == "") &&
                        key.adfsGuid != null &&
                        key.adfsGuid != ""
                    )
                        that.contactListwithoutUserName.push(key);
                });
            },
            GetContactsWithUserNames: function (data) {
                var that = this;
                var pagingRecords = [];
                var activeUsersList = [];
                var isActiveUserHide = that.selectedAccount.hideInactiveContact;
                if (isActiveUserHide) {
                    data.forEach(function (key) {
                        if (key != "undefined" && key.deactivated != null && !key.deactivated)
                            activeUsersList.push(key);
                    });
                }

                that.pagedcontactListwithUserName = [];
                if (activeUsersList != null && activeUsersList.length != 0 && activeUsersList != "" && activeUsersList != "undefined") 
                    pagingRecords = activeUsersList.slice(0, 20);
                else
                    pagingRecords = data.slice(0, 20);
                if (pagingRecords != null && pagingRecords.length != 0 && pagingRecords != "" && pagingRecords != "undefined") {
                    pagingRecords.forEach(function (key) {
                        if (
                            typeof key != "undefined" &&
                            (key.userName != null && key.userName != "") && key.isStatusRetrived != true &&
                            key.adfsGuid != null &&
                            key.adfsGuid != ""
                        )
                            that.pagedcontactListwithUserName.push(key);
                    });
                }
            }
        }
    };
</script>